import { render, staticRenderFns } from "./DetailProcessus.vue?vue&type=template&id=0fec03b2&scoped=true"
import script from "./DetailProcessus.vue?vue&type=script&lang=js"
export * from "./DetailProcessus.vue?vue&type=script&lang=js"
import style0 from "./DetailProcessus.vue?vue&type=style&index=0&id=0fec03b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fec03b2",
  null
  
)

export default component.exports